module.exports = __webpack_public_path__ + "static/unisexhamper-ddd83c30796dacac1204d03a9cb5d94f.jpeg";